import loader from "./stores/loader";
import error from "./stores/error";

const REQUEST_PATH = "/api/";

const errorHandler = error => {
    loader.hide();

    return [error, null];
};

const apiGet = (url, show_loader = true) => {

    if (show_loader) loader.show();

    return fetch(REQUEST_PATH + url)
        .then(async res => {
            const result = await res.json()

            loader.hide();

            if (result.error) {
                error.show(result.error);
                return [result.error, null];
            }

            return [null, result.data];
        }).catch(errorHandler);
}

const apiPost = (url, data, show_loader = true) => {

    if (show_loader) loader.show();

    return fetch(REQUEST_PATH + url, {
        method: "POST",
        body: JSON.stringify(data)
    })
        .then(async res => {
            const result = await res.json()

            loader.hide();

            if (result.error) {
                error.show(result.error);
                return [result.error, null];
            }

            return [null, result.data];
        }).catch(errorHandler);
}

const initApp = () => {
    return apiGet('initialize', false);
}


const login = (username, password) => {
    return apiPost('client_login', {username, password});
}

const logout = () => apiGet('client_logout');
const updateClientAccount = (account) => apiPost('update_account', {account});
const getClientCredits = () => apiGet('client_credits');
const getClientList = (search) => apiPost('clients_list', {search});
const getClientCreditsHistory = (params) => apiPost('client_credits_history', { params });
const ClientCreditsHistorySave = entry => apiPost('client_credits_history_update', { entry });
const getCreditsHistory = (params) => apiPost('credits_history', { params });
const clientLoad = id => apiPost('client_load', { id });
const clientSave = client => apiPost('client_save', { client });
const clientDelete = id => apiPost('client_delete', { id });

const getMessagesPending = (search) => apiPost('sms_pending', {search});
const getMessagesSent = (page, search) => apiPost('sms_sent', {page, search});

const loadSms = (id) => apiPost('sms_load', { id });
const sendSms = (sms) => apiPost('sms_send', { sms });
const setSmsBlobkStatus = (id, block_status) => apiPost('sms_block_status', { id, block_status });
const validateSms = (sms) => apiPost('sms_validate', { sms });
const getMessageReports = (id) =>  apiPost('sms_reports', { id });

const cancelSms = (id) => apiPost('sms_cancel', { id });

const groupLoad = id => apiPost('group_load', { id });
const groupSave = group => apiPost('group_save', { group });
const groupDelete = id => apiPost('group_delete', { id });
const groupRemoveMobile = (id, mobile) => apiPost('group_remove_mobile', { id, mobile });
const groupsRemoveMobiles = mobiles => apiPost('groups_remove_mobiles', { mobiles });

const memberSave = member => apiPost('member_save', { member });
const memberDelete = id => apiPost('member_delete', { id });
const membersSearch = search => apiPost('members_search', {search});
const membersRemoveFromGroup = data => apiPost('members_remove_from_group', {data});
const membersAddToGroup = data => apiPost('members_add_to_group', {data});

const mobileSearch = mobile => apiPost('mobile_search', { mobile });
const validateMobiles = mobiles => apiPost('validate_mobiles', { mobiles });

const sendPassword = username => apiPost('send_password', { username });

export {
    initApp,
    login,
    logout,
    getClientCredits,
    getClientList,
    getClientCreditsHistory,
    ClientCreditsHistorySave,
    getCreditsHistory,
    clientLoad,
    clientSave,
    clientDelete,
    updateClientAccount,
    //getClientGroups,
    groupLoad,
    groupSave,
    groupDelete,
    groupRemoveMobile,
    groupsRemoveMobiles,
    memberSave,
    memberDelete,
    membersSearch,
    membersRemoveFromGroup,
    membersAddToGroup,
    loadSms,
    sendSms,
    validateSms,
    cancelSms,
    setSmsBlobkStatus,
    getMessagesPending,
    getMessagesSent,
    getMessageReports,
    mobileSearch,
    validateMobiles,
    sendPassword
};
